module.exports = __webpack_public_path__ + "img/light_blonde.ffebde1e.svg";